<template>
  <div class="nav-bar">
    <div class="topnav" id="myTopnav">
      <p v-on:click="$router.push('/tournamentsOverview')">MY TOURNAMENTS</p>
      <p v-if="currentUser" v-on:click="$router.push('/teamsOverview')">TEAMS</p>
      <p v-if="!currentUser" v-on:click="$router.push('/login')" class="signIn">LOGIN</p>
      <p v-if="!currentUser" v-on:click="$router.push('/signup')" class="signIn">SIGN UP</p>
      <p v-if="currentUser" v-on:click="logout" class="signIn">LOGOUT</p>
      <p class="icon" v-on:click="menu()">&#9776;</p>
    </div>
  </div>
</template>


<script>
export default {
  name: 'Navbar',

  computed: {
    currentUser(){
      return this.$store.state.currentUser;
    }
  },
  methods: {
    menu() {
    var x = document.getElementById("myTopnav");
    if (x.className === "topnav") {
        x.className += " responsive";
    } else {
        x.className = "topnav";
    }
  },
    logout(){
      this.$store.dispatch('logout',{callback: this.success, errorCallback: this.error});
    },
    success(){
      this.$router.push('/login');
    },
    error(errorMessage){
      console.log(errorMessage);
    }

  }

}
</script>


<style scoped>
.topnav {
  overflow: hidden;
  background-color: #333333e1;
}

.topnav p {
  float: left;
  display: block;
  color: orange;
  text-align: center;
  padding: 20px 16px;
  text-decoration: none;
  font-size: 16px;
  margin: 0px;
  cursor: pointer;
}

.topnav p:hover {
  background-color: #ddd;
  color: black;
}

.active {
  background-color: #4CAF50;
  color: white;
}

.topnav .icon {
  display: none;
}
.topnav p.signIn{
  float: right;
}

@media screen and (max-width: 600px) {
  .topnav p:not(:first-child) {display: none;}
  .topnav p.icon {
    float: right;
    display: block;
  }
}

@media screen and (max-width: 600px) {
  .topnav.responsive {position: relative;}
  .topnav.responsive .icon {
    position: absolute;
    right: 0;
    top: 0;
  }
  .topnav.responsive p {
    float: none;
    display: block;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue